/**
 * Отображение платформ в виджетах
 * ================================
 *
 * Подписи, цвета и порядок платформ для графиков и таблиц с разбивкой
 * по платформам. 'all' — агрегат по всем платформам сразу.
 */

import { retention as retentionSpecs } from '@ggstat/chart-specs';

// Подписи, цвета и порядок — shared/chart-specs/specs/retention.json (их же
// рисует MCP-сервер)
const platformSpecs = retentionSpecs.platforms;

export const ALL_PLATFORMS = platformSpecs.all;

export const PLATFORM_LABELS = platformSpecs.labels;

export const PLATFORM_COLORS = platformSpecs.colors;

// Пунктир линии агрегата «Все платформы»
export const AGGREGATE_DASH = platformSpecs.aggregateDash;

const PLATFORM_ORDER = platformSpecs.order;

export function getPlatformLabel(platform) {
  return PLATFORM_LABELS[platform] || platform;
}

export function getPlatformColor(platform) {
  return PLATFORM_COLORS[platform] || platformSpecs.fallbackColor;
}

/**
 * Сортирует список платформ в каноническом порядке (агрегат первым),
 * незнакомые — в конце по алфавиту.
 */
export function sortPlatforms(platforms) {
  return [...platforms].sort((a, b) => {
    const aIndex = PLATFORM_ORDER.indexOf(a);
    const bIndex = PLATFORM_ORDER.indexOf(b);
    if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
}
